import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AriOkIcon, OkIcon } from '~/assets/icons';
import useStore from '~/store';
import { center, container, description, textDesc, title } from './styles';

export default function HelpZipcodePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orgParam = searchParams.get('org');
  const { contractResponse, promotionData, products } = useStore((store) => ({
    contractResponse: store.contractResponse,
    promotionData: store.promotionData,
    products: store.products
  }));

  const isOnlyGuarantee = products?.length === 1 && String(products[0]?.product_id) === '9';

  const navigateToContract = () => {
    const params = new URLSearchParams();
    params.set('cid', String(contractResponse?.contract_id ?? ''));
    params.set('source', 'email');
    if (orgParam) params.set('org', orgParam);
    navigate(`/contract/?${params.toString()}`);
  };

  const isPromotionFlow = promotionData?.has_promotion === true && promotionData?.is_promotion_available === true;
  return (
    <Container maxWidth="sm" sx={container}>
      <Box sx={[center]}>
        {isPromotionFlow ? <OkIcon /> : <AriOkIcon />}
        {isPromotionFlow ? (
          <Typography color="primary" variant="h4" fontWeight="bold" sx={{ marginTop: '2.25rem' }}>
            Promoção ativada!
          </Typography>
        ) : isOnlyGuarantee ? (
          <Typography variant="h5" sx={center} fontWeight="bold">
            Garantia ativada!
          </Typography>
        ) : (
          <Typography variant="h5" sx={center} fontWeight="bold">
            Pagamento aprovado!
          </Typography>
        )}
      </Box>
      {!isPromotionFlow && (
        <Box>
          <Typography color="primary" variant="h4" sx={title}>
            {isOnlyGuarantee ? 'Falta pouco...' : 'Falta pouco!'}
          </Typography>
        </Box>
      )}
      <Box>
        <Typography sx={description} textAlign="center">
          {isPromotionFlow && (
            <Typography component="span" fontWeight="bold">
              Agora falta pouco!{' '}
            </Typography>
          )}
          {isOnlyGuarantee
            ? 'Para a sua garantia começar a valer, precisamos de mais alguns dados!'
            : 'Para o seu seguro começar a valer, precisamos de mais alguns dados!'}
        </Typography>
      </Box>
      <Box sx={[center]} onClick={navigateToContract}>
        <Button variant="contained">Preencher dados agora</Button>
        <Box>
          <Typography color="primary" fontWeight="bold" sx={[center, textDesc]}>
            {isOnlyGuarantee
              ? 'Não consegue agora? Enviamos um e-mail para você terminar quando puder.'
              : 'Caso não consiga preencher agora, enviaremos um e-mail com instruções para finalizar assim que possível.'}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}
